import { render, staticRenderFns } from "./SocialSync.vue?vue&type=template&id=39bb809c&scoped=true&"
import script from "./SocialSync.vue?vue&type=script&lang=js&"
export * from "./SocialSync.vue?vue&type=script&lang=js&"
import style0 from "./SocialSync.vue?vue&type=style&index=0&id=39bb809c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb809c",
  null
  
)

export default component.exports